import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Documento from "model/documentos/Documento";
import DocumentoSolicitacaoRevisao from "model/documentos/DocumentoSolicitacaoRevisao";
import RespostaSolicitacao from "model/documentos/RespostaSolicitacao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

export default class DocumentoSolicitacaoRevisaoService implements BaseServiceCadastros<DocumentoSolicitacaoRevisao> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/documentoSolicitacaoRevisao/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<DocumentoSolicitacaoRevisao>((resolve, reject): void => {
            api
                .get(`/documentoSolicitacaoRevisao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(documento: DocumentoSolicitacaoRevisao) {
        return new Promise<DocumentoSolicitacaoRevisao>((resolve, reject): void => {
            let url = `/documentoSolicitacaoRevisao/incluir`;
            api
                .post(url, JSON.stringify(documento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(model: DocumentoSolicitacaoRevisao | FormData, idConta?: number | null): Promise<DocumentoSolicitacaoRevisao> {
        throw new Error("Method not implemented.");
    }
    excluir(id: number | string, idConta?: number | null): Promise<void> {
        throw new Error("Method not implemented.");
    }

    responder(dados: RespostaSolicitacao) {
        return new Promise<DocumentoSolicitacaoRevisao>((resolve, reject): void => {
            let url = `/documentoSolicitacaoRevisao/responder`;
            api
                .post(url, JSON.stringify(dados))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    categorias() {
        return new Promise<CategoriaDocumento[]>((resolve, reject): void => {
            api
                .get(`/documentoSolicitacaoRevisao/categorias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/documentoSolicitacaoRevisao/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    documentos() {
        return new Promise<Documento[]>((resolve, reject): void => {
            api
                .get(`/documentoSolicitacaoRevisao/documentos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    getRespostasFilter(): any[] {
        return [
            { label: 'Aceita', value: 'A' },
            { label: 'Rejeitada', value: 'R' }
        ]
    }
    getResposta(resposta: any): string {
        if (resposta === 'ACEITA') {
            return 'Aceita';
        } else if (resposta === 'REJEITADA') {
            return 'Rejeitada';
        }

        return "Não respondida";
    }
}